// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReceivingBody_body__TUnTu {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 95%;
  margin: 0 auto;
}

/* 🔍 Поиск */
.ReceivingBody_searchBar__CSPRr {
  margin-top: 10px;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 6px 10px;
  gap: 8px;
  position: relative; /* <- добавлено */
}


.ReceivingBody_searchBar__CSPRr input {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 14px;
  color: #333;
}

.ReceivingBody_searchActions__h1bbf {
  display: flex;
  gap: 6px;
}

.ReceivingBody_searchActions__h1bbf button {
  background: #f5f5f5;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s;
}

.ReceivingBody_searchActions__h1bbf button:hover {
  background: #eaeaea;
}


.ReceivingBody_itemsWrapper__8fFIW {
  flex: 1 1;
  display: flex;
  padding: 10px 0;
  gap: 10px;
}

.ReceivingBody_itemsList__VKNdh {
  flex: 1 1;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #eee;
}

.ReceivingBody_empty__7lCf9 {
  text-align: center;
  color: #777;
}

.ReceivingBody_noCategoryBtn__Vvpct {
  padding: 10px 14px;
  border-radius: 6px;
  background: rgba(24,115,70,1);
  color: white;
  border: none;
  cursor: pointer;
}

/* 🔹 Нижняя панель */
.ReceivingBody_footer__gE8\\+I {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  border-top: 1px solid #ddd;
  background: #f8f9fc;
}

.ReceivingBody_leftPanel__0gZ7Z {
  display: flex;
  align-items: center;
  gap: 20px;
}

.ReceivingBody_summary__FtQSV {
  font-size: 16px;
  font-weight: 500;
}

.ReceivingBody_leftButtons__FqgxM {
  display: flex;
  gap: 10px;
}

.ReceivingBody_clearBtn__ZCYwx {
  background: #1e1e1e;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
}

.ReceivingBody_createBtn__uMRlt {
  background:  rgba(24,115,70,1);
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
}

.ReceivingBody_rightPanel__U96ft {
  display: flex;
  gap: 10px;
}

.ReceivingBody_rightPanel__U96ft button {
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
}

.ReceivingBody_editBtn__NDW9R {
  border: 1px solid #1e1e1e;
  color: #1e1e1e;
}

.ReceivingBody_deleteBtn__u9KId {
  border: 1px solid #1e1e1e;
  color: #1e1e1e;
}

.ReceivingBody_plusBtn__iZ1ZW {
  border: 1px solid #1e1e1e;
  color: #1e1e1e;
}

.ReceivingBody_minusBtn__WZohx {
  background: #6c757d;
  color: white;
}

/* Подсказки поиска */
.ReceivingBody_suggestionList__SPkVL {
  position: absolute;
  top: 100%; /* под инпутом */
  left: 0;
  right: 0;
  max-height: 200px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  z-index: 100;
  margin-top: 4px;
  padding: 0;
  list-style: none;
}

.ReceivingBody_suggestionList__SPkVL li {
  padding: 10px 12px;
  cursor: pointer;
  transition: background 0.2s;
}

.ReceivingBody_suggestionList__SPkVL li:hover {
  background: rgba(24,115,70,0.1);
}

/* Таблица товаров */
.ReceivingBody_productsTable__eA7JN {
  width: 100%;
  border-spacing: 0 6px; /* расстояние между строками */
}

.ReceivingBody_productsTable__eA7JN thead th {
  background: rgba(232, 243, 237, 1);
  color: rgba(29, 135, 82, 1);
  font-weight: 600;
  padding: 10px;
  text-align: left;
  border-bottom: 2px solid rgba(29, 135, 82, 0.5);
}

.ReceivingBody_productsTable__eA7JN tbody tr {
  background: #fff;
  transition: background 0.2s;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.ReceivingBody_productsTable__eA7JN tbody tr:hover {
  background: rgba(232, 243, 237, 0.5);
}

.ReceivingBody_productsTable__eA7JN td {
  padding: 8px 10px;
  color: #333;
  vertical-align: middle;
}

.ReceivingBody_productsTable__eA7JN td input {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 4px 6px;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
}

/* Скролл при переполнении */
.ReceivingBody_itemsList__VKNdh {
  flex: 1 1;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #eee;
  overflow-x: auto;
}

.ReceivingBody_quantityWrapper__27Ugl {
  display: flex;
  align-items: center;
  gap: 5px;
}

.ReceivingBody_quantityBtn__tj2hw {
  width: 28px;
  height: 28px;
  background-color: rgba(29, 135, 82, 1);
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ReceivingBody_quantityBtn__tj2hw:hover {
  opacity: 0.9;
}

.ReceivingBody_quantityText__purbD {
  min-width: 24px;
  text-align: center;
}

/* 🔹 Футер */
.ReceivingBody_footer__gE8\\+I {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #f8f9fc;
  border-top: 1px solid #ddd;
  border-radius: 0 0 10px 10px;
  gap: 20px;
  flex-wrap: wrap;
}

.ReceivingBody_footerLeft__vdkQ4 {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ReceivingBody_footerTop__UGNn8 {
  font-size: 16px;
  font-weight: 500;
  color: #1d8752;
}

.ReceivingBody_footerActions__TNax3 {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.ReceivingBody_footerBtn__jGIBG {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid rgba(29,135,82,1);
  border-radius: 8px;
  color: rgba(29,135,82,1);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 60px;
}

.ReceivingBody_footerBtn__jGIBG:hover {
  background: rgba(29,135,82,0.1);
}

.ReceivingBody_footerBtn__jGIBG span {
  font-size: 12px;
}

.ReceivingBody_footerBtn__jGIBG svg {
  width: 55px;
  height: 55px;
}

.ReceivingBody_footerBtn__jGIBG.ReceivingBody_danger__96qS3 {
  border-color: #e74c3c;
  color: #e74c3c;
}

.ReceivingBody_footerBtn__jGIBG.ReceivingBody_danger__96qS3:hover {
  background: rgba(231,76,60,0.1);
}

.ReceivingBody_footerRight__6gndM {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ReceivingBody_total__yOdI7 {
  text-align: right;
  font-size: 16px;
  font-weight: 600;
  color: #1d8752;
}

.ReceivingBody_pay__JgTII {
  background: rgba(24,115,70,1);
  color: #fff;
  border: none;
  padding: 10px 18px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.ReceivingBody_pay__JgTII:hover {
  background: rgba(29,135,82,0.9);
}



`, "",{"version":3,"sources":["webpack://./src/pages/SalesPages/ReceivingBody.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,UAAU;EACV,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,kBAAkB,EAAE,iBAAiB;AACvC;;;AAGA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,SAAS;EACT,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAS,EAAE,gBAAgB;EAC3B,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,qBAAqB,EAAE,8BAA8B;AACvD;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,4BAA4B;EAC5B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":[".body {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  width: 95%;\n  margin: 0 auto;\n}\n\n/* 🔍 Поиск */\n.searchBar {\n  margin-top: 10px;\n  display: flex;\n  align-items: center;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding: 6px 10px;\n  gap: 8px;\n  position: relative; /* <- добавлено */\n}\n\n\n.searchBar input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  color: #333;\n}\n\n.searchActions {\n  display: flex;\n  gap: 6px;\n}\n\n.searchActions button {\n  background: #f5f5f5;\n  border: 1px solid #dcdcdc;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.searchActions button:hover {\n  background: #eaeaea;\n}\n\n\n.itemsWrapper {\n  flex: 1 1;\n  display: flex;\n  padding: 10px 0;\n  gap: 10px;\n}\n\n.itemsList {\n  flex: 1;\n  background: #fff;\n  border-radius: 10px;\n  border: 1px solid #eee;\n}\n\n.empty {\n  text-align: center;\n  color: #777;\n}\n\n.noCategoryBtn {\n  padding: 10px 14px;\n  border-radius: 6px;\n  background: rgba(24,115,70,1);\n  color: white;\n  border: none;\n  cursor: pointer;\n}\n\n/* 🔹 Нижняя панель */\n.footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 20px;\n  border-top: 1px solid #ddd;\n  background: #f8f9fc;\n}\n\n.leftPanel {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.summary {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.leftButtons {\n  display: flex;\n  gap: 10px;\n}\n\n.clearBtn {\n  background: #1e1e1e;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.createBtn {\n  background:  rgba(24,115,70,1);\n  color: white;\n  border: none;\n  padding: 8px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.rightPanel {\n  display: flex;\n  gap: 10px;\n}\n\n.rightPanel button {\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.editBtn {\n  border: 1px solid #1e1e1e;\n  color: #1e1e1e;\n}\n\n.deleteBtn {\n  border: 1px solid #1e1e1e;\n  color: #1e1e1e;\n}\n\n.plusBtn {\n  border: 1px solid #1e1e1e;\n  color: #1e1e1e;\n}\n\n.minusBtn {\n  background: #6c757d;\n  color: white;\n}\n\n/* Подсказки поиска */\n.suggestionList {\n  position: absolute;\n  top: 100%; /* под инпутом */\n  left: 0;\n  right: 0;\n  max-height: 200px;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n  z-index: 100;\n  margin-top: 4px;\n  padding: 0;\n  list-style: none;\n}\n\n.suggestionList li {\n  padding: 10px 12px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.suggestionList li:hover {\n  background: rgba(24,115,70,0.1);\n}\n\n/* Таблица товаров */\n.productsTable {\n  width: 100%;\n  border-spacing: 0 6px; /* расстояние между строками */\n}\n\n.productsTable thead th {\n  background: rgba(232, 243, 237, 1);\n  color: rgba(29, 135, 82, 1);\n  font-weight: 600;\n  padding: 10px;\n  text-align: left;\n  border-bottom: 2px solid rgba(29, 135, 82, 0.5);\n}\n\n.productsTable tbody tr {\n  background: #fff;\n  transition: background 0.2s;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n}\n\n.productsTable tbody tr:hover {\n  background: rgba(232, 243, 237, 0.5);\n}\n\n.productsTable td {\n  padding: 8px 10px;\n  color: #333;\n  vertical-align: middle;\n}\n\n.productsTable td input {\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 4px 6px;\n  font-size: 14px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Скролл при переполнении */\n.itemsList {\n  flex: 1;\n  background: #fff;\n  border-radius: 10px;\n  border: 1px solid #eee;\n  overflow-x: auto;\n}\n\n.quantityWrapper {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.quantityBtn {\n  width: 28px;\n  height: 28px;\n  background-color: rgba(29, 135, 82, 1);\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  font-size: 18px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.quantityBtn:hover {\n  opacity: 0.9;\n}\n\n.quantityText {\n  min-width: 24px;\n  text-align: center;\n}\n\n/* 🔹 Футер */\n.footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  background: #f8f9fc;\n  border-top: 1px solid #ddd;\n  border-radius: 0 0 10px 10px;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.footerLeft {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.footerTop {\n  font-size: 16px;\n  font-weight: 500;\n  color: #1d8752;\n}\n\n.footerActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.footerBtn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 10px 12px;\n  background: #fff;\n  border: 1px solid rgba(29,135,82,1);\n  border-radius: 8px;\n  color: rgba(29,135,82,1);\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  min-width: 60px;\n}\n\n.footerBtn:hover {\n  background: rgba(29,135,82,0.1);\n}\n\n.footerBtn span {\n  font-size: 12px;\n}\n\n.footerBtn svg {\n  width: 55px;\n  height: 55px;\n}\n\n.footerBtn.danger {\n  border-color: #e74c3c;\n  color: #e74c3c;\n}\n\n.footerBtn.danger:hover {\n  background: rgba(231,76,60,0.1);\n}\n\n.footerRight {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.total {\n  text-align: right;\n  font-size: 16px;\n  font-weight: 600;\n  color: #1d8752;\n}\n\n.pay {\n  background: rgba(24,115,70,1);\n  color: #fff;\n  border: none;\n  padding: 10px 18px;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.pay:hover {\n  background: rgba(29,135,82,0.9);\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `ReceivingBody_body__TUnTu`,
	"searchBar": `ReceivingBody_searchBar__CSPRr`,
	"searchActions": `ReceivingBody_searchActions__h1bbf`,
	"itemsWrapper": `ReceivingBody_itemsWrapper__8fFIW`,
	"itemsList": `ReceivingBody_itemsList__VKNdh`,
	"empty": `ReceivingBody_empty__7lCf9`,
	"noCategoryBtn": `ReceivingBody_noCategoryBtn__Vvpct`,
	"footer": `ReceivingBody_footer__gE8+I`,
	"leftPanel": `ReceivingBody_leftPanel__0gZ7Z`,
	"summary": `ReceivingBody_summary__FtQSV`,
	"leftButtons": `ReceivingBody_leftButtons__FqgxM`,
	"clearBtn": `ReceivingBody_clearBtn__ZCYwx`,
	"createBtn": `ReceivingBody_createBtn__uMRlt`,
	"rightPanel": `ReceivingBody_rightPanel__U96ft`,
	"editBtn": `ReceivingBody_editBtn__NDW9R`,
	"deleteBtn": `ReceivingBody_deleteBtn__u9KId`,
	"plusBtn": `ReceivingBody_plusBtn__iZ1ZW`,
	"minusBtn": `ReceivingBody_minusBtn__WZohx`,
	"suggestionList": `ReceivingBody_suggestionList__SPkVL`,
	"productsTable": `ReceivingBody_productsTable__eA7JN`,
	"quantityWrapper": `ReceivingBody_quantityWrapper__27Ugl`,
	"quantityBtn": `ReceivingBody_quantityBtn__tj2hw`,
	"quantityText": `ReceivingBody_quantityText__purbD`,
	"footerLeft": `ReceivingBody_footerLeft__vdkQ4`,
	"footerTop": `ReceivingBody_footerTop__UGNn8`,
	"footerActions": `ReceivingBody_footerActions__TNax3`,
	"footerBtn": `ReceivingBody_footerBtn__jGIBG`,
	"danger": `ReceivingBody_danger__96qS3`,
	"footerRight": `ReceivingBody_footerRight__6gndM`,
	"total": `ReceivingBody_total__yOdI7`,
	"pay": `ReceivingBody_pay__JgTII`
};
export default ___CSS_LOADER_EXPORT___;
